import { Input, Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController } from '../../../node_modules/@ionic/angular';
import { LoadingController, AlertController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AllServicesService } from '../all-services.service';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})
export class RatingPage implements OnInit {
  appointmentData:any = [];
  rate:number = 0;
  starBox:any = [];
  loading:any;

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController,
    public storage: Storage,
    public allServices: AllServicesService,
    public alertCtrl: AlertController, 
    public loadingCtrl: LoadingController,
    public toastController: ToastController
  ) { 
    this.starBox = [1,2,3,4,5];
    this.appointmentData = navParams.get('appointment');
    console.log(this.appointmentData);

    if(this.appointmentData.rating && parseFloat(this.appointmentData.rating)!=0){
      this.rate = parseFloat(this.appointmentData.rating);
    }
  }

  ngOnInit() {
  }

  async dismiss(){
    await this.modalCtrl.dismiss();
  }

  selectStar(rate,$event) {
    if($event.offsetX > 26){
      this.rate = rate + 1;
    }else{
      this.rate = rate + .5;
    }
    console.log(this.rate);
  }

  rateDoc(){
    console.log('Rate: ', this.rate);
    console.log('Appointment Id: ', this.appointmentData.appointment_id);

    if(this.rate>0 && this.appointmentData.appointment_id!=''){
      this.showLoader('');
      this.allServices.rateDoctor(this.appointmentData.appointment_id, this.rate).subscribe((result) => {
        console.log(result);
        this.dismissLoading();
        this.presentToast('Successfully rated the doctor.');
        this.dismiss();
      }, (err) => {
        console.log("error...",err);
        this.presentToast('Something went wrong!');
      });
    }

  }

  async presentAlert(msg) {
    let alert = await this.alertCtrl.create({
      header: 'Alert',
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }


  async showLoader(msg){
    this.loading = await this.loadingCtrl.create({message: msg, backdropDismiss:true});
    this.loading.present();
  }
  async dismissLoading() {
    console.log(this.loading);
    await this.loading.dismiss();
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      animated: true,
      cssClass: "my-toast-green",
      duration: 2000
    });
    toast.present();
  }

}
